import React from 'react';
import ReactDOM from 'react-dom/client';
import './Core/index.css';
import App from './Core/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);